<div class="main-container">
	<div class="__form-container">
		<img class="__logo" src="assets/images/logo.jpg" alt="Logo" />
		<p class="text-muted-dark" *ngIf="fromLoginMessage">{{fromLoginMessage}}</p>
		<p class="text-muted-dark" *ngIf="!errorMessage">Se enviará un enlace de restablecimiento de contraseña. Por favor, ingrese el correo electrónico registrado en el sistema.</p>
		<form class="__form" [formGroup]="form" (ngSubmit)="onSubmit()">
			<div class="__field-wrapper">
				<mat-form-field class="__field" appearance="standard">
					<mat-label>Correo Electrónico</mat-label>
					<input
						formControlName="email"
						matInput
						type="text"
						placeholder="Ingrese su correo"
					/>
					<mat-error
						*ngIf="emailField?.touched && emailField?.hasError('required')"
					>
						El correo electronico es requerido
					</mat-error>
				</mat-form-field>
			</div>
			<button mat-raised-button class="__button" color="primary" [disabled]="form.invalid || loading">
				{{ loading ? 'Cargando' : 'Enviar enlace' }}
				<mat-icon class="mr1" *ngIf="!loading">arrow_forward</mat-icon>
			</button>
		</form>
		<button mat-button class="__button" color="primary" (click)="navigateToLogin()">
			<mat-icon class="mr1">arrow_back</mat-icon>
			Volver al inicio de sesión
		</button>
		<app-request-support-button></app-request-support-button>
	</div>
	<div class="__image-container">
		<img
			class="__image"
			src="assets/images/background_login.png"
			alt="Login Background"
		/>
	</div>
</div>